import Link from "next/link"
import styles from "./ErrorPage.module.scss"

export default function ErrorPage() {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <div className={styles.iconWrapper}>
          <div className={styles.outerCircle}>
            <div className={styles.innerCircle}>
              <div className={styles.emoji}>🐹</div>
            </div>
          </div>
          <div className={styles.badgeWrapper}>
            <div className={styles.badge}>Whoops!</div>
          </div>
        </div>
      </div>
      <h1 className={styles.title}>Well, this is awkward...</h1>
      <p className={styles.description}>
        Our digital hamsters took a coffee break at the wrong time! Don&apos;t worry though - we&apos;ll get things
        running smoothly again.
      </p>
      <Link href="/" className={styles.button}>
        Go Home
      </Link>
    </div>
  )
}
